import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import { Logo } from '../Common/Logo';
import { CategoryMenu } from '../Common/CategoryMenu';
import { SearchBox } from '../Common/SearchBox';

class BuyerDashboardHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
                <Navbar fixed="top">
                    <div className="header_area" >
                        <div className="row">
                            <div className="col-md-2 pl-5">
                                <Logo />
                            </div><div className="col-md-2 catagory mb-5 pb-4">
                                <CategoryMenu />
                            </div>

                            <div className="col-md-4 ">
                                <SearchBox />
                            </div>
                            <div className="col-md-4 ">
                                <div className="row">
                                    <div className="col-md-3"></div>
                                    <div className="col-md-2">
                                        <img alt="" src={require("../../assets/images/notification.jpg")} height="50%" width="60%" className="mt-3 ml-5" />
                                    </div>
                                    <div className="col-md-2">
                                        <Link to={'/buyer-direct-message-list'}>
                                            <img alt="" src={require("../../assets/images/push.png")} height="50%" width="60%" className="mt-3 ml-4" />
                                        </Link>
                                    </div>
                                    <Link to={'/buyer-dashboard'} className="col-md-2">
                                        <img alt="" src={require("../../assets/images/profile-icon.jpg")} height="50%" width="60%" className="mt-3 " style={{ borderLeft: '1px solid gray', borderRight: '1px solid gray', padding: '5px' }} />
                                    </Link>
                                    
                                    <div className="col-md-0"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Navbar>
            </div>
        )
    }
}
export { BuyerDashboardHeader }